import { useTranslation } from "react-i18next";
import "./style.css";

const Services = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Hero Section */}
      <section className="services-hero">
        <div className="services-hero-content">
          {/* <div className="hero-emoji">🪙</div> */}
          <h1 className="font-bauhaus-medium">{t("services.hero.title")}</h1>
          <p className="font-tomorrow">{t("services.hero.description")}</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-main">
        <div className="services-container">
          
          {/* Service 1: Trading */}
          <div className="service-block">
            <div className="service-header">
              <div className="service-number">01</div>
              <h2 className="font-bauhaus-medium">{t("services.trading.title")}</h2>
            </div>
            <div className="service-content">
              <p className="service-tagline font-tomorrow">
                {t("services.trading.tagline")}
              </p>
              <p className="service-description font-tomorrow">
                {t("services.trading.description")}
              </p>
              <div className="service-features">
                <h4 className="font-tomorrow">{t("services.features.title")}</h4>
                <ul className="font-tomorrow">
                  <li>{t("services.trading.feature1")}</li>
                  <li>{t("services.trading.feature2")}</li>
                  <li>{t("services.trading.feature3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Service 2: Custody */}
          <div className="service-block">
            <div className="service-header">
              <div className="service-number">02</div>
              <h2 className="font-bauhaus-medium">{t("services.custody.title")}</h2>
            </div>
            <div className="service-content">
              <p className="service-tagline font-tomorrow">
                {t("services.custody.tagline")}
              </p>
              <p className="service-description font-tomorrow">
                {t("services.custody.description")}
              </p>
              <div className="service-features">
                <h4 className="font-tomorrow">{t("services.commitment.title")}</h4>
                <ul className="font-tomorrow">
                  <li>{t("services.custody.feature1")}</li>
                  <li>{t("services.custody.feature2")}</li>
                  <li>{t("services.custody.feature3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Service 3: Compliance */}
          <div className="service-block">
            <div className="service-header">
              <div className="service-number">03</div>
              <h2 className="font-bauhaus-medium">{t("services.compliance.title")}</h2>
            </div>
            <div className="service-content">
              <p className="service-tagline font-tomorrow">
                {t("services.compliance.tagline")}
              </p>
              <p className="service-description font-tomorrow">
                {t("services.compliance.description")}
              </p>
            </div>
          </div>

          {/* Service 4: Institutional */}
          <div className="service-block">
            <div className="service-header">
              <div className="service-number">04</div>
              <h2 className="font-bauhaus-medium">{t("services.institutional.title")}</h2>
            </div>
            <div className="service-content">
              <p className="service-description font-tomorrow">
                {t("services.institutional.description")}
              </p>
              <div className="service-features">
                <h4 className="font-tomorrow">{t("services.solutions.title")}</h4>
                <ul className="font-tomorrow">
                  <li>{t("services.institutional.feature1")}</li>
                  <li>{t("services.institutional.feature2")}</li>
                  <li>{t("services.institutional.feature3")}</li>
                  <li>{t("services.institutional.feature4")}</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="services-cta-content">
          <h2 className="font-bauhaus-medium">{t("services.cta.title")}</h2>
          <button className="btn-primary cursor-pointer" onClick={() => window.location.href="/lien-he"}>
            {t("services.cta.button")}
          </button>
        </div>
      </section>
    </>
  );
};

export default Services;
